import React from "react";
import { useNavigate } from "react-router-dom";
function TopRolesRisk({ table_data }) {
  const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const navigate = useNavigate();

  return (
    <>
      <style>
        {`
                    .table thead tr th {
                        white-space: normal !important;
                        word-wrap: break-word;
                        padding: 6px 8px;
                    }
                    
                    .table tbody tr td {
                    color : #202c4b;
                    }
                    
                `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Role Name</th>
              <th>Client Name</th>
              <th>Score</th>
              <th>BU Head</th>
            </tr>
          </thead>
          <tbody>
            {table_data?.length > 0 &&
              table_data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <h6
                      style={{ cursor: "pointer" }}
                      title={item?.role_name}
                      className="fw-medium title fs-12"
                      onClick={() => {
                        navigate(
                          "/role/view/" + item.role_id,
                        );
                      }}
                    >
                      {item?.role_name?.slice(0, 15)}....
                    </h6>
                  </td>
                  <td>
                    <h6 className="fw-medium">{item.company_name}</h6>
                    <span className="badge badge-info badge-xs">
                      {item.industry}
                    </span>
                  </td>
                  <td>
                    <h6
                      className={`avatar avatar-sm avatar-rounded text-fixed-white fs-12 fw-medium ${
                        item.weighted_points < 80 ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {item.weighted_points}
                    </h6>
                  </td>
                  <td>
                    <span
                      className="avatar avatar-rounded"
                      title={item.cdu_name}
                    >
                      <img
                        src={`${REACT_APP_PINE_BASE_URL}/files/media/${item.cdu_userpic}`}
                        className="border border-white"
                        alt={item.cdu_name}
                      />
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TopRolesRisk;
